/** Seconds before the user can request another OTP. */
export const AUTH_OTP_RESEND_COOLDOWN_SECONDS = 120

/** Readable terms page (Nuxt route). */
export const AUTH_TERMS_ROUTE = '/terms'

/** Default route when leaving terms without a redirect query. */
export const AUTH_TERMS_BACK_ROUTE = '/login'
